import React from "react";
import restorelungs from "../assets/articale/5.jpg";

const LungsRestore = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        {
          "Clear Your Lungs & Restore Clean Breathing Forever (Without Painful Procedures)"
        }
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={restorelungs}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
      
        <p>
          <span> {"Thanks to the"}</span>{" "}
          <span className="bg-[#ffbf00]  font-bold !">
            {"unique composition"}
          </span>{" "}
          {"of a range of natural ingredients, the foundation of which is"}{" "}
          <span className="  font-bold">{"100% natural Mullein,"}</span> {" "}
          {"a forgotten herb used in ancient Rome and Greece as a powerful expectorant for various lung health problems,"}{" "}
          <span className="  font-bold">
            {
              "Herbal Tea Therapy’s “Breathe” "
            }
          </span>
          {"provides an all-natural solution."}
        </p>
        <p>
          {"Dr. Ali’s formula also contains a special"}{" "}
          <span className="  font-bold">
            {
              "blend of vitamins, antioxidants, and amino acids that clear out toxic buildup from years of inhaling pollution, allergens, smoke, and more."
            }
          </span>{" "}
        </p>
        <h2 className="text-2xl font-bold text-[#303030] mb-6">
        {"What is Mullein and how does it work?"} 
        </h2>
        <div>
          <div>
            <p className="font-bold">{"Step 1: Reduce Inflammation"}</p>
          </div>
          <div>
            <p>
            {"The primary active ingredient in Mullein is "}<span className="font-bold">{"Verbascoside. "}</span>{"  This powerful compound has anti-inflammatory, antibacterial, and antiviral properties that work together to soothe the respiratory tract, reduce inflammation, and combat infections."}
            </p>
          </div>
        </div>
        <div>
          <div>
            <p className="font-bold">{"Step 2: Clearing the Airways"}</p>
          </div>
          <div>
            <p>
              {
                "Mullein’s saponins are natural expectorants, which help loosen and expel mucus from the lungs. This is crucial for clearing the airways, making breathing easier, and reducing coughing."
              }
            </p>
          </div>
        </div>
        <div>
          <div>
            <p className="font-bold">{"Step 3: Healing Power—Flavonoids"}</p>
          </div>
          <div>
            <p>
              {
                " Mullein is rich in flavonoids that help reduce oxidative stress and protect lung tissue from damage, leading to faster healing and improved lung health."
              }
            </p>
          </div>
        </div>
        <p>
          {
            "Mullein provides a comprehensive approach to respiratory health, making it an invaluable remedy for those suffering from conditions like "
          }{" "}
          <span className="font-bold">
            {"asthma, bronchitis, and general congestion."}
          </span>
        </p>
        <p>
        {"That’s how "}{" "}
        <span className="font-bold">
        {
            "Herbal Tea Therapy’s “Breathe” "
          }
        </span>
          
         {" was born—out of the necessity for proven, natural formulas that truly work."}
        </p>
      </div>
    </div>
  );
};

export default LungsRestore;
